import { useAppTranslation } from "@/utils";
import { CapabilityLayout } from "@/utils/DigitalAccount/capabilityLayout";
import { Col, Row, Typography } from "@payping/web-components";
import { DoubleArrowLeft, PresentationChart, Speedometer, ZapFast } from "@payping/icons";
import classNames from "classnames";
import {
  clickbaitAccountManagementId,
  clickbaitEarlySettlementId,
  clickbaitShortTermLoanId,
  clickbaitTransferId,
} from "@/assets/googleTrackIds";
import styles from "../../assets/scss/DigitalAccount/digital.module.scss";

const Capability = () => {
  const { t } = useAppTranslation();

  return (
    <Row gutter={[8, 8]}>
      <Col xs={24} xl={6}>
        <CapabilityLayout
          title={
            <Typography.Text strong className={"tw:flex! tw:justify-center!"}>
              {t("digitalAccount.capability.transferFunds")}
            </Typography.Text>
          }
          icon={
            <div className="background--gray100 tw:flex! tw:justify-center! tw:p-4!">
              <DoubleArrowLeft width={32} />
            </div>
          }
          modalIcon={
            <div className={classNames(styles.background_icon_capability, "tw:flex! tw:justify-center! tw:p-4!")}>
              <DoubleArrowLeft className={"color--cta"} width={64} />
            </div>
          }
          modalDescription={<Typography.Text>{t("digitalAccount.capability.transferFundsModalDesc")}</Typography.Text>}
          data-google-track={clickbaitTransferId}
        />
      </Col>
      <Col xs={24} xl={6}>
        <CapabilityLayout
          title={
            <Typography.Text strong className={"tw:flex! tw:justify-center!"}>
              {t("digitalAccount.capability.digitalAccountManagement")}
            </Typography.Text>
          }
          icon={
            <div className="background--gray100 tw:flex! tw:justify-center! tw:p-4!">
              <PresentationChart width={32} />
            </div>
          }
          modalIcon={
            <div className={classNames(styles.background_icon_capability, "tw:flex! tw:justify-center! tw:p-4!")}>
              <PresentationChart className={"color--cta"} width={64} />
            </div>
          }
          modalDescription={
            <Typography.Text>{t("digitalAccount.capability.digitalAccountManagementModalDesc")}</Typography.Text>
          }
          data-google-track={clickbaitAccountManagementId}
        />
      </Col>
      <Col xs={24} xl={6}>
        <CapabilityLayout
          title={
            <Typography.Text strong className={"tw:flex! tw:justify-center!"}>
              {t("digitalAccount.capability.shortTermLoan")}
            </Typography.Text>
          }
          icon={
            <div className="background--gray100 tw:flex! tw:justify-center! tw:p-4!">
              <Speedometer width={32} />
            </div>
          }
          modalIcon={
            <div className={classNames(styles.background_icon_capability, "tw:flex! tw:justify-center! tw:p-4!")}>
              <Speedometer className={"color--cta"} width={64} />
            </div>
          }
          modalDescription={<Typography.Text>{t("digitalAccount.capability.shortTermLoanModalDesc")}</Typography.Text>}
          data-google-track={clickbaitShortTermLoanId}
        />
      </Col>
      <Col xs={24} xl={6}>
        <CapabilityLayout
          title={
            <Typography.Text strong className={"tw:flex! tw:justify-center!"}>
              {t("digitalAccount.capability.earlySettlement")}
            </Typography.Text>
          }
          icon={
            <div className="background--gray100 tw:flex! tw:justify-center! tw:p-4!">
              <ZapFast width={32} />
            </div>
          }
          modalIcon={
            <div className={classNames(styles.background_icon_capability, "tw:flex! tw:justify-center! tw:p-4!")}>
              <ZapFast className={"color--cta"} width={64} />
            </div>
          }
          modalDescription={
            <Typography.Text>{t("digitalAccount.capability.earlySettlementModalDesc")}</Typography.Text>
          }
          data-google-track={clickbaitEarlySettlementId}
        />
      </Col>
    </Row>
  );
};

export default Capability;
